/**
 * ESRI is delivering Date in UTC milliseconds
 * --> convert to ISO string accepted by typescript-json-serializer
 * @param esriDate
 */
export const esriToDate = (esriDate: number): string => new Date(esriDate).toISOString();

/**
 * Convert to milliseconds (to send to feature layer)
 * @param date
 */
export const dateToEsri = (date: string): number => Date.parse(date);

/**
 * ESRI is delivering boolean as 0 or 1
 * --> convert to accepted by typescript-json-serializer
 * @param esriBoolean
 */
export const esriToBoolean = (esriBoolean: number): boolean =>
	esriBoolean === 1;

/**
 * Convert to 0 or 1 (to send to feature layer)
 * @param bool
 */
export const booleanToEsri = (bool: boolean): number =>
	bool ? 1 : 0;

